import { onEvent, onLoaded } from "@/utils";
import { isLicenseActive } from "./license";

const settings = ajaxpress_vars.settings || {}
const isLicenseValid = isLicenseActive()

// Prevent multiple initializations
let animationsInitialized = false

const Animations = () => {
    // Prevent re-initialization
    if (animationsInitialized) {
        return
    }

    let progressTimer = null

    onLoaded( () => {
        // Prevent re-initialization
        if (animationsInitialized) {
            return
        }

        // Mark as initialized
        animationsInitialized = true

        onEvent('ajaxpress-loading', loading)
        onEvent('ajaxpress-updated', updated)
    })
    
    const loading = (e) => {
        // Show Progressbar.
        if ( settings.progressbar ) {
            showProgressBar()
        }

        // Show Loader.
        if ( settings.loader ) {
            showLoader()
        }

        // Animate cursor.
        if ( ajaxpress_vars.settings.animate_cursor ) {
            animateCursor()
        }

        // Animate content - remove animation class (Premium feature).
        if ( settings.content_animation && isLicenseValid ) {
            const animationName = settings.content_animation_name || 'fade'
            document.body.classList.remove(`ajaxpress-animate-${animationName}`)
        }
    }

    const updated = (e) => {
        // Hide Progressbar.
        if ( settings.progressbar ) {
            hideProgressBar()
        }

        // Hide Loader.
        if ( settings.loader ) {
            hideLoader()
        }

        // Animate content - add animation class with delay (Premium feature).
        if ( settings.content_animation && isLicenseValid ) {
            const animationName = settings.content_animation_name || 'fade'
            const delay = parseFloat(settings.content_animation_delay) || 0

            setTimeout(() => {
                document.body.classList.add(`ajaxpress-animate-${animationName}`)
            }, delay * 1000)
        }

        // Stop animate cursor.
        if ( ajaxpress_vars.settings.animate_cursor ) {
            stopAnimateCursor()
        }

        // Scroll to top (skip for comment submissions - they handle their own scrolling).
        const source = e?.detail?.source || window.ajaxpress_state.updateSource
        if ( settings.scroll_to_top && source !== 'comment' ) {
            scrollToTop()
        }
    }

    // Show progressbar.
    const showProgressBar = () => {
        if ( progressTimer ) {
            return
        }

        const progress_bar = document.querySelector('.ajaxpress-progressbar');

        if ( !progress_bar ) {
            return;
        }

        // Disable CSS transitions for immediate reset
        progress_bar.style.transition = 'none';
        progress_bar.style.display = 'block'
        progress_bar.style.width = '0%';

        // Force reflow to ensure the width reset is applied
        progress_bar.offsetHeight;

        // Enable CSS transition and animate to 90% (let CSS handle the animation)
        progress_bar.style.transition = 'width 4.5s ease-out';
        progress_bar.style.width = '90%';

        // Set flag to prevent multiple animations
        progressTimer = true;
    }

    // Stop progressbar.
    const hideProgressBar = () => {
        progressTimer = null

        const progress_bar = document.querySelector('#ajaxpress-progressbar');
        if ( !progress_bar ) {
            return;
        }

        // Use CSS transition for smooth completion
        progress_bar.style.transition = 'width 0.3s ease-out';

        if ( settings.progressbar_auto_hide ) {
            progress_bar.style.display = 'none'
        } else {
            progress_bar.style.width = '100%'
        }
    }

    // Start loader.
    const showLoader = () => {
        const loader = document.querySelector('.ajaxpress-loader')
        if ( !loader ) return;
        
        loader.classList.remove('ajaxpress-loader-hidden')
    }

    const hideLoader = () => {
        const loader = document.querySelector('.ajaxpress-loader')
        if ( !loader ) return;

        loader.classList.add('ajaxpress-loader-hidden')
    }

    // Animate cursor. 
    const animateCursor = () => {
        document.body.classList.add('ajaxpress-animate-cursor')
    }

    // Stop animate cursor.
    const stopAnimateCursor = () => {
        document.body.classList.remove('ajaxpress-animate-cursor')
    }

    // Scroll to top.
    const scrollToTop = () => {
        setTimeout(function() {
            // Use native smooth scroll for better performance
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }, 100);
    }

}

export default Animations